/**
 * Canonical `service` values that tag every API log line (top-level, filterable
 * in Better Stack). Set on HTTP requests via the `x-ygoarg-service` header
 * (frontends, through the SDK's `setAppInfo`) or directly on the backend via
 * `requestContext.run({ service })` (workers/tasks/cron).
 *
 * Single source of truth — import this instead of hardcoding string literals.
 */
export const ServiceName = {
  // Frontend apps (sent via x-ygoarg-service)
  WEB: 'WEB',
  FOLDER: 'FOLDER',
  CALENDAR: 'CALENDAR',
  RANKING: 'RANKING',
  MOBILE_APP: 'MOBILE-APP',
  TOURNAMENT_APP: 'TOURNAMENT-APP',
  MARKETPLACE: 'MARKETPLACE',
  EXTENSION: 'EXTENSION',
  DECKLIST: 'DECKLIST',
  // App del lead de public events (apps/public-events)
  PUBLICS: 'PUBLICS',
  // Overlays, editor y panel de control de las transmisiones (apps/streaming)
  STREAMING: 'STREAMING',
  // Scripts de la Mac mini (scripts/mac-mini/), que no importan este paquete y
  // lo escriben a mano.
  MAC_MINI: 'MAC-MINI',
  // Backend execution contexts
  TASK: 'TASK', // job enqueued on-demand (API/CLI)
  CRON: 'CRON', // job triggered by the scheduler
  WORKER: 'WORKER', // worker process lifecycle (boot/shutdown)
} as const;

export type ServiceName = (typeof ServiceName)[keyof typeof ServiceName];
